import { CircleButton, CircleButtonProps } from '@brokerbay/elements-web';
import { type Moment } from 'moment';
import React from 'react';
import { type BookingTimeSelectContextType } from '../BookingTimeSelectContext';
import { type DateStates } from '../types';

export type DateSelectorCellProps = DateStates & {
  isAdmin?: boolean;
  cellDate: Moment;
  onClick: BookingTimeSelectContextType['onDateClick'];
};

const DateSelectorCell: React.FC<DateSelectorCellProps> = ({
  isAppointmentDate,
  isBeforeActiveDate,
  isOfferDate,
  isOpenHouseDate,
  isPast,
  isUnavailableAfterDate,
  isUnavailableDate,
  isAdmin,
  cellDate,
  onClick,
}) => {
  let type: CircleButtonProps['type'] = 'default';
  if (isAppointmentDate) type = 'primary';
  else if (isPast || isBeforeActiveDate) type = 'light';
  else if (isUnavailableAfterDate && isAdmin) type = 'danger';
  else if (isUnavailableDate || isUnavailableAfterDate) type = 'dangerLight';
  else if (isOfferDate) type = 'warning';
  else if (isOpenHouseDate) type = 'primaryLight';

  return (
    <CircleButton
      datatype={type}
      dataCy={cellDate.format('YYYY-MM-DD')}
      type={type}
      onClick={e => {
        e.stopPropagation(); // Disable antd click event on containing td element
        onClick({
          isAppointmentDate,
          isBeforeActiveDate,
          isOfferDate,
          isOpenHouseDate,
          isPast,
          isUnavailableAfterDate,
          isUnavailableDate,
          date: cellDate,
        });
      }}
    >
      {cellDate.date().toString()}
    </CircleButton>
  );
};

export default DateSelectorCell;
